// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"tAw6gZn_GY"};